<button app-mat-flat-button color="primary" (click)="onClick()" [class.copied]="isCopied">
  <span class="text">
    <span *ngIf="isCopied">Copied!</span>
    <span *ngIf="!isCopied">Copy Code</span>
  </span>
</button>
